import React, { useEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { SpeedDial, SpeedDialIcon, SpeedDialAction } from '@mui/material';

// assets
import EditIcon from '@mui/icons-material/EditTwoTone';
import ChatIcon from '@mui/icons-material/Chat';
import Modal from './ChatBot/Modal';
import { useTranslation } from 'react-i18next';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
// =============================|| UI SPEEDDIAL - CUSTOM CLOSE ICON ||============================= //

export default function Extension() {
    const theme = useTheme();
    const { t } = useTranslation();
    const [isOpenChat, setOpenChat] = useState<boolean>(false);
    const { resetTranscript } = useSpeechRecognition();
    const handleOpenChat = () => {
        setOpenChat(!isOpenChat);
    };
    const handleOpenVoiceRecognitionUnlimit = () => {
        resetTranscript();
        SpeechRecognition.startListening({ continuous: true, interimResults: true, language: 'vi-VN' });
    };
    useEffect(() => {
        if (isOpenChat) {
            handleOpenVoiceRecognitionUnlimit();
        } else {
            SpeechRecognition.stopListening();
        }
    }, [isOpenChat]);
    return (
        <>
            <SpeedDial
                ariaLabel="SpeedDial tooltip"
                sx={{ position: 'fixed', bottom: 16, right: 16 }}
                icon={<SpeedDialIcon openIcon={<EditIcon />} />}
            >
                <SpeedDialAction
                    icon={<ChatIcon sx={{ color: theme.palette.grey[900] }} />}
                    tooltipTitle={
                        <>
                            <span style={{ color: theme.palette.grey[900] }}>{t("Assistant")}</span>
                        </>
                    }
                    tooltipOpen
                    onClick={handleOpenChat}
                />
            </SpeedDial>
            {isOpenChat && (
                <Modal open={isOpenChat} handleDrawerOpen={handleOpenChat} />
            )}
        </>
    );
}
